export const NODE_DEFS = {
  'entry-event':     { group: 'entry',  label: 'Event Trigger',     ico: 'bolt',           icoC: 'rgba(184,66,66,.15)',  icoT: '#C86060', accentType: 'entry',  hasBranches: false },
  'entry-schedule':  { group: 'entry',  label: 'Schedule Entry',    ico: 'calendar_month', icoC: 'rgba(110,98,168,.15)', icoT: '#8878C0', accentType: 'entry',  hasBranches: false },
  'entry-segment':   { group: 'entry',  label: 'Segment Entry',     ico: 'group',          icoC: 'rgba(72,120,176,.15)', icoT: '#6090C8', accentType: 'entry',  hasBranches: false },
  'entry-api':       { group: 'entry',  label: 'API / Webhook',     ico: 'api',            icoC: 'rgba(122,110,176,.15)',icoT: '#A09AC8', accentType: 'entry',  hasBranches: false },
  'action-push':     { group: 'action', label: 'Push Notification', ico: 'notifications',  icoC: 'rgba(184,66,66,.12)',  icoT: '#C86060', accentType: 'action', hasBranches: false },
  'action-inapp':    { group: 'action', label: 'In-App Message',    ico: 'phone_iphone',   icoC: 'rgba(72,120,176,.12)',  icoT: '#6090C8', accentType: 'action', hasBranches: false },
  'action-whatsapp': { group: 'action', label: 'WhatsApp',          ico: 'forum',          icoC: 'rgba(79,155,111,.12)', icoT: '#63B887', accentType: 'action', hasBranches: false },
  'action-email':    { group: 'action', label: 'Email',             ico: 'mail',           icoC: 'rgba(110,98,168,.12)', icoT: '#8878C0', accentType: 'action', hasBranches: false },
  'action-sms':      { group: 'action', label: 'SMS',               ico: 'sms',            icoC: 'rgba(160,124,48,.12)', icoT: '#C09848', accentType: 'action', hasBranches: false },
  'action-webhook':  { group: 'action', label: 'Webhook',           ico: 'webhook',        icoC: 'rgba(122,110,176,.12)',icoT: '#A09AC8', accentType: 'action', hasBranches: false },
  'wait-relative':   { group: 'wait',   label: 'Relative Wait',     ico: 'hourglass_empty',icoC: 'rgba(160,124,48,.12)', icoT: '#C09848', accentType: 'wait',   hasBranches: false },
  'wait-absolute':   { group: 'wait',   label: 'Until Time',        ico: 'schedule',       icoC: 'rgba(160,124,48,.1)',  icoT: '#C09848', accentType: 'wait',   hasBranches: false },
  'logic-condition': { group: 'logic',  label: 'Condition Split',   ico: 'call_split',     icoC: 'rgba(79,155,111,.12)', icoT: '#63B887', accentType: 'logic',  hasBranches: true, branches: ['Yes','No'],  branchStyles: ['yes','no'] },
  'logic-ab':        { group: 'logic',  label: 'A/B Split',         ico: 'science',        icoC: 'rgba(122,110,176,.12)',icoT: '#A09AC8', accentType: 'logic',  hasBranches: true, branches: ['A','B'],    branchStyles: ['va','vb'] },
  'logic-goal':      { group: 'logic',  label: 'Goal Check',        ico: 'ads_click',      icoC: 'rgba(79,155,111,.12)', icoT: '#63B887', accentType: 'logic',  hasBranches: false },
  'logic-exit':      { group: 'exit',   label: 'Exit Journey',      ico: 'logout',         icoC: 'rgba(80,80,80,.15)',   icoT: '#888888', accentType: 'exit',   hasBranches: false },
};

export const ACCENT_COLORS = {
  entry:  '#C86060',
  action: '#5080B8',
  wait:   '#C09848',
  logic:  '#63B887',
  exit:   '#888888',
};

export function defaultCfg(type) {
  const m = {
    'entry-event':     { event: 'app_install', filter: '' },
    'entry-schedule':  { cron: '0 18 * * *', tz: 'IST +5:30', preset: '' },
    'entry-segment':   { segmentId: 'power-users' },
    'entry-api':       { description: 'External CRM trigger', secret: '' },
    'action-push':     { title: '', body: '', link: '', v1: '', v2: '' },
    'action-inapp':    { type: 'Banner', title: '', cta: '', body: '' },
    'action-whatsapp': { template: '', v1: '', v2: '' },
    'action-email':    { subject: '', preheader: '', template: 'Promotional', v1: '' },
    'action-sms':      { message: '' },
    'action-webhook':  { url: '', method: 'POST', payload: '' },
    'wait-relative':   { amount: '1', unit: 'hours', waitType: 'Fixed duration' },
    'wait-absolute':   { rule: 'next_day_noon', tz: 'IST +5:30' },
    'logic-condition': { condType: 'event_performed', event: 'lead_submitted', timeWindow: 'ever' },
    'logic-ab':        { splitA: '50', splitB: '50' },
    'logic-goal':      { event: 'purchase' },
    'logic-exit':      { reason: 'journey_complete' },
  };
  return { ...(m[type] || {}) };
}

export const PALETTE_GROUPS = [
  {
    label: 'Entry',
    nodes: ['entry-event','entry-schedule','entry-segment','entry-api'],
  },
  {
    label: 'Actions',
    nodes: ['action-push','action-inapp','action-whatsapp','action-email','action-sms','action-webhook'],
  },
  {
    label: 'Logic',
    nodes: ['wait-relative','wait-absolute','logic-condition','logic-ab','logic-goal','logic-exit'],
  },
];
